<template>
  <div>
    <background/>
    <smart-header/>
    <div class="wh100" layout="row top-center">
      <div class="conditions">
        <div>
          <div>
            <h2>
              <strong>
                Teilnahmebedingungen für das Gewinnspiel „smart electric challenge“
              </strong>
            </h2>
            <p style="font-size: 1.1rem;">
              Für die Teilnahme am Gewinnspiel „<strong>smart electric challenge</strong>“ (im Folgenden „ <strong>Gewinnspiel</strong>“) der Daimler AG Mercedes-Benz Cars
              Vertrieb Deutschland, Mühlenstraße 30, 10243 Berlin (im Folgenden „<strong>Daimler AG</strong>“) gelten die folgenden Bedingungen („ <strong>Teilnahmebedingungen</strong>“).
            </p>
            <h3>
              1. Teilnahme
            </h3>

            <p>
              1.1 Das Gewinnspiel wird in der Zeit vom 11.05.2018 um 10:00 Uhr bis
              zum 08.09.2018 um 23:59 Uhr durchgeführt. Teilnahmeschluss ist der
              08.09.2018 um 23:59 Uhr. Der Gewinner wird in der KW 37 ermittelt und
              per E-Mail kontaktiert.
            </p>
            <p>
              1.2 Teilnahmeberechtigt sind Personen über 18 Jahre, die ihren Wohnsitz
              in Deutschland haben. Sämtliche an der Entwicklung / Durchführung des
              Gewinnspiels beteiligten Personen (z.B. Mitarbeiter der Daimler AG,
              Agenturen, Berater, Lieferanten) sowie deren jeweilige Familien- und
              Haushaltsmitglieder sind von der Teilnahme ausgeschlossen.
            </p>
            <p>
              1.3 Die Teilnahme an dem Gewinnspiel erfolgt durch die Beteiligung an
              den einzelnen Aktionen auf dem Event. Jeder Teilnehmer generiert sowohl
              online auf „Instagram“ mit dem jeweiligen Hashtag der Stadt als auch im
              Quiz vor Ort und während der Probefahrt Energiepunkte für die eigene
              Stadt. Die Stadt mit den meisten Energiepunkten qualifiziert sich für
              die finale Verlosung eines smart EQ fortwo. Als Sofortgewinn ist ein
              Goody Bag vor Ort möglich.
            </p>
            <p>
              1.4 Der Teilnehmer erklärt, dass sämtliche Personenangaben der Wahrheit
              entsprechen. Andernfalls kann ein Ausschluss gemäß Ziffer 1.5 erfolgen.
            </p>
            <p>
              1.5 Die Daimler AG ist berechtigt, Teilnehmer vom Gewinnspiel
              auszuschließen, die den Teilnahmevorgang oder die Verlosung
              manipulieren bzw. dieses versuchen oder gegen die Teilnahmebedingungen
              oder die guten Sitten verstoßen, indem sie Beiträge mit
              pornographischem, sexistischem, rassistischem, rechtsextremem,
              gewaltverherrlichendem, beleidigendem oder kommerziellem Inhalt posten.
              Ausgeschlossen wird auch, wer nicht in Deutschland wohnt oder wer
              unwahre Personenangaben macht.
            </p>
            <h3>
              2. Durchführung des Gewinnspiels
            </h3>
            <p>
              <strong></strong>
            </p>
            <p>
              2.1 Der Gewinner wird aus allen Teilnehmern innerhalb der
              Gewinnerstadt, welche die Teilnahmevoraussetzungen erfüllen, per
              Juryentscheid ermittelt. Der Auswahlprozess findet geheim statt.
            </p>
            <p>
              2.2 Die Entscheidung der Jury ist endgültig und in sämtlichen mit
              diesem Gewinnspiel verbundenen Angelegenheiten verbindlich.
            </p>
            <p>
              2.3 Via E-Mail wird der Gewinner informiert. Mit dem Gewinner wird nach
              seiner Rückmeldung die Übergabe abgestimmt. Sollte sich der Gewinner
              nicht binnen 72 Stunden per E-Mail gemeldet haben, wird ein
              Alternativgewinner ermittelt. Der Sofortgewinn wird direkt vor Ort
              ermittelt.
            </p>
            <p>
              2.4 Der Gewinn kann nicht in bar ausgezahlt werden. Der Gewinnanspruch
              kann nicht an Dritte abgetreten werden.
            </p>
            <p>
              2.5 Im Falle unvorhergesehener Umstände, die nicht von der Daimler AG
              beeinflusst werden können, behält sie sich das Recht vor, eine dem Wert
              entsprechend gleichwertige oder höherwertige Siegerprämie anzubieten.
            </p>
            <p>
              2.6 Wird aus Gründen, die im Ermessen des Veranstalters liegen, der
              Zutritt zu der Veranstaltung verweigert oder findet das Event nicht
              statt oder wird vorzeitig beendet, so übernimmt die Daimler AG hierfür
              keine Haftung.
            </p>
            <h3>
              3. Haftung
            </h3>
            <p>
              <strong></strong>
            </p>
            <p>
              3.1 Die Daimler AG haftet nur für vorsätzlich oder grob fahrlässig
              verursachte Schäden.
            </p>
            <p>
              3.2 Ist der Gewinn mit einem Sach- oder Rechtsmangel behaftet, so ist
              die Daimler AG nur dann verpflichtet, dem Gewinner den daraus
              entstehenden Schaden zu ersetzen, wenn die Daimler AG diesen Mangel
              arglistig verschwiegen hat.
            </p>
            <h3>
              4. Vorzeitige Beendigung des Gewinnspiels
            </h3>
            <p>
              <strong></strong>
            </p>
            <p>
              4.1 Die Daimler AG behält sich vor, das Gewinnspiel jederzeit, ohne
              vorherige Ankündigung, abzubrechen oder zu unterbrechen. Dies gilt
              insbesondere, wenn aus technischen Gründen (z.B. Viren im
              Computersystem, Manipulation oder Fehler in der Hard- und/oder
              Software) oder aus rechtlichen Gründen eine ordnungsgemäße Durchführung
              des Gewinnspiels nicht gewährleistet werden kann.
            </p>
            <p>
              4.2 Erfüllungs- und Schadensersatzansprüche des Teilnehmers bei
              vorzeitiger Beendigung des Gewinnspiels nach Ziffer 4.1. sind, im
              Rahmen der Regelung der Ziffer 3, ausgeschlossen.
            </p>
            <h3>
              5. Datenschutz
            </h3>
          </div>
          <p>
            5.1 Die Daimler AG erhebt, verarbeitet und nutzt als verantwortliche
            Stelle im Sinne des deutschen Bundesdatenschutzgesetzes alle im Rahmen
            dieses Gewinnspiels an die Daimler AG mitgeteilten personenbezogenen
            Daten ausschließlich zum Zweck der Durchführung des Gewinnspiels. Die
            Daimler AG gibt diese personenbezogenen Daten nicht an Dritte weiter,
            hiervon ausgenommen sind die bei der Durchführung dieses Gewinnspiels
            unterstützenden, in Deutschland ansässigen Dienstleistungsunternehmen
            („<strong>Auftragsdatenverarbeiter</strong>“).
          </p>
          <p>
            5.2 Der Teilnehmer hat das Recht auf unentgeltliche Auskunft über die
            von ihm gespeicherten personenbezogenen Daten sowie auf Berichtigung,
            Sperrung oder Löschung dieser personenbezogenen Daten. Um Ihre
            genannten Rechte geltend zu machen, wenden Sie sich bitte an: Daimler
            AG Mercedes-Benz Cars Vertrieb Deutschland, Mühlenstraße 30, 10243
            Berlin.
          </p>
          <p>
            5.3 Im Falle eines Löschungsbegehrens vor Ende des Gewinnspiels, ist
            mit diesem Löschungsbegehren die Beendigung der Teilnahme am
            Gewinnspiel verbunden, wenn es der weiteren Teilnahme entgegensteht. In
            diesem Fall ist ein Gewinn nicht mehr möglich.
          </p>
          <p>
            5.4 Ergänzend gelten unsere Datenschutzbestimmungen
            <a href="http://www.smart.com/de/de/index/footer/data-protection.html">
              https://www.smart.com/de/de/index/footer/data-protection.html
            </a>
          </p>
          <h3>
            6. Nutzung Foto- und Videomaterial
          </h3>
          <p>
            <p>6.1	Mit dem Hochladen der grafischen Inhalte (z.B. Videos, Fotos) sichern Sie zu, dass Sie die dazu erforderlichen Urheber- sowie sonstigen Rechte (z.B. ein Recht zur Veröffentlichung)besitzen. Weiter sichern Sie zu, dass die im Film/auf den Fotos abgebildeten Personen, mit der Veröffentlichung einverstanden sind. Bei Personen unter 18 Jahren gilt das Einverständnis
          des Erziehungsberechtigten.</p>

          <p>6.2	Mit dem Hochladen der Filmaufnahmen/Fotoaufnahmen räumen Sie der Daimler AG ein einfaches, räumlich und zeitlich unbeschränktes sowie an Dritte übertragbares Recht ein, die Filmaufnahmen zu  Dokumentationszwecken und kommerziellen Zwecken zu archivieren, zu.</p>
          <p>6.3	bearbeiten, zu vervielfältigen, zu verbreiten, auszustellen und öffentlich wiederzugeben. Die vorgenannten Verwertungsrechte werden unabhängig von den Übertragungs- und Wiedergabewegen eingeräumt; sie umfassen insbesondere das Recht zur Verwertung mittels elektronischer Medien, insbesondere des (Intranets oder) Internets.</p>

          <p>6.4	Weiter verzichten Sie mit dem Einstellen bzw. Hochladen der Filmaufnahmen ausdrücklich auf Ihr Recht zur Nennung als Urheber. Eine Vergütungspflicht von der Daimler AG wird durch die Nutzungsrechtsüberlassung nicht begründet.</p>

          </p>
          <h3>
            7. Sonstige Regelungen
          </h3>
          <p>
            7.1 Die Teilnahmebedingungen und die gesamte Rechtsbeziehung zwischen den
            Teilnehmern und der Daimler AG unterliegen ausschließlich dem Recht der
            Bundesrepublik Deutschland unter Ausschluss dessen Kollisionsregeln und des
            UN-Kaufrechts.
          </p>
          <p>
            7.2 Sollten einzelne Teilnahmebedingungen unwirksam sein oder werden, wird
            die Wirksamkeit der übrigen Bestimmungen hierdurch nicht berührt. An die
            Stelle einer unwirksamen Klausel tritt die gesetzliche Bestimmung.
          </p>
          <p>
            3.3 Der Rechtsweg ist ausgeschlossen.
          </p>
        </div>
      </div>
    </div>
    <spacing value="2rem"/>
    <smart-footer/>
  </div>

</template>

<script>
  import SmartHeader from "./SmartHeader";
  import Background from "./Background";
  import SmartFooter from "./SmartFooter";
  import Spacing from "./blocks/Spacing";

  export default {
    name: "ParticipationConditions",
    components: {Spacing, SmartFooter, Background, SmartHeader},
    activated() {
      window.scrollTo(0, 0);
    }
  }
</script>

<style lang="scss" scoped>
  .conditions {
    font-weight: 100;
    font-size: 0.9rem;
    width: 90%;
    max-width: 1000px;
    margin-top: 12vw;

    @media screen and (min-width: 1200px) {
      margin-top: 170px;
    }

    @media screen and (max-width: 800px) {
      margin-top: 90px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ParticipationConditions.vue